import { getToken } from "api";
import axios from "axios";
import { ApiResponse } from "common/interfaces";
import * as API_CHALLENGES from "../challenges/challenge.api.routes";
import { API_RESSOURCES } from "../teacher/teacher.routes";
import * as API_ROUTES from "./rooms.api.routes";
import { API_CLASSES, API_RESSOUCES } from "./rooms.api.routes";

export const findAll = async (
  id: string | undefined
): Promise<ApiResponse | undefined> => {
  try {
    if (!id) throw new Error("Merci de passer un id");
    const token = await getToken();
    const response = await axios.get(API_ROUTES.findAll(id), {
      headers: {
        Authorization: `Bearer ${token}`,
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const findByLevel = async (
  id: any | undefined,
  teacher: any | undefined
): Promise<ApiResponse | undefined> => {
  try {
    if (!id) throw new Error("Merci de passer un niveau");
    const token = await getToken();
    const response = await axios.get(API_ROUTES.findByLevel(id, teacher), {
      headers: {
        Authorization: `Bearer ${token}`,
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const findByUser = async (
  teacher: any | undefined
): Promise<ApiResponse | undefined> => {
  try {
    if (!teacher) throw new Error("Merci de passer un id professeur");
    const token = await getToken();
    const response = await axios.get(API_ROUTES.findByUser(teacher), {
      headers: {
        Authorization: `Bearer ${token}`,
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const findOne = async (
  id: string | undefined
): Promise<ApiResponse | undefined> => {
  try {
    if (!id) throw new Error("Merci de passer un id");
    const token = await getToken();
    const response = await axios.get(API_ROUTES.getRoomById(id), {
      headers: {
        Authorization: `Bearer ${token}`,
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createRoom = async (
  createRoomDto: any
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    const response = await axios.post(API_ROUTES.CREATE_ROOM, createRoomDto, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createOpenRoom = async (
  data: any
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    const response = await axios.post(`${process.env.REACT_APP_API_URL_RESSOURCES}/classes`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createPackRoom = async (
  data: any
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    const response = await axios.post(`${process.env.REACT_APP_API_URL_RESSOURCES}/classes`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createRoomParentOrganism = async (
  data: any,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    const response = await axios.post(`${API_RESSOURCES}/classes`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const findRegistredStudents = async (
  id: string | undefined,
  search?: string | undefined
): Promise<ApiResponse | undefined> => {
  try {
    if (!id) throw new Error("Merci de passer un id");
    const token = await getToken();
    const response = await axios.get(
      API_ROUTES.getRegistredStudents(id, search),
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const challengerUneClasse = async (
  challenderUneClasseDto: any
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    const response = await axios.post(
      API_CHALLENGES.CHALLENGE_CLASS,
      challenderUneClasseDto,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchPublicationByClass = async (
  idClasse: string | undefined,
  page: any,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(`${API_RESSOUCES}/contributions?page=${page}&classe=${idClasse}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const quitClass = async (
  classCode: string | undefined,
  idStudent: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.delete(`${API_CLASSES}/${classCode}/register/${idStudent}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const removeStudentFromClass = async (
  classCode: string,
  studentId: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.delete(`${API_RESSOUCES}/classes/${classCode}/register/${studentId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const fetchInvitations = async (
  studentId: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(`${API_RESSOUCES}/classes/collective/class/listStudentInvitations/${studentId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const deleteClassroom = async (
  classeId: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.delete(`${API_RESSOUCES}/classes/safe/remove/${classeId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const archiveClassroom = async (
  classeId: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.post(`${API_RESSOUCES}/classes/${classeId}/archive`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};